<div class="overlay" *ngIf="isOpen">
  <div class="modal-card">
    <mat-icon class="icon">lock</mat-icon>

    <h1>Estamos cerrados</h1>

    <p>
      En este momento no estamos tomando pedidos.<br />
      Podés recorrer el menú, pero no realizar encargos.
    </p>

    <button mat-flat-button color="primary" (click)="cerrar()">Cerrar</button>
  </div>
</div>
